import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-outcome',
    imports: [],
    templateUrl: './outcome.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './outcome.component.scss'
})
export class OutcomeComponent {

}
